import pl from "@locales/questionnaires/pl.json";
import en from "@locales/questionnaires/en.json";

export default {
  pl: pl,
  en: en,
};
